import "./shop.css";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
export default function Shop() {
  return (
    <div className="head-text">
      <div className="head-image">
        <img
          className="shopImg"
          alt=""
          src="https://cdn.road.cc/sites/default/files/styles/main_width/public/horizontal-dark-road-2-spot.jpg"
        />
      </div>
      <div className="center__text">
        <h2>
          <span>Product catalog coming soon!!</span>
        </h2>
      </div>
    </div>
  );
}
